// extracted by mini-css-extract-plugin
export default {"container":"productName_container__hlXus","badge":"productName_badge__csy2N"};